import { render } from "./AnswersByCategory.vue?vue&type=template&id=60b6c0da&scoped=true"
import script from "./AnswersByCategory.vue?vue&type=script&lang=js"
export * from "./AnswersByCategory.vue?vue&type=script&lang=js"

import "./AnswersByCategory.vue?vue&type=style&index=0&id=60b6c0da&scoped=true&lang=scss"

import exportComponent from "/Users/stepanmaksimov/Documents/Claude/Projects/A.sk/answerio-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b6c0da"]])

export default __exports__